import {memo, lazy, Suspense} from 'react'
import {createPortal} from 'react-dom'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useDockedPanel} from '../../contexts/DockedPanelContext'
import {ssrSafeDocument} from '@github-ui/ssr-utils'
import {DOCKED_SIDE_PANEL_CONTENT_ID} from './DockedSidePanel'
import {Panel} from './Panel'
import {Spinner} from '@primer/react'
import type {Repository} from '@github-ui/current-repository'

const PullRequestsSidePanel = lazy(async () => {
  const m = await import('@github-ui/agent-sessions/components/task-view/PullRequestsSidePanel')
  return {default: m.PullRequestsSidePanel}
})

interface AgentSessionsSidePanelProps {
  isOpen: boolean
  repository: Repository
  pullRequestNumber: number
}

export const AgentSessionsSidePanel = memo(function AgentSessionsSidePanel({
  isOpen,
  repository,
  pullRequestNumber,
}: AgentSessionsSidePanelProps) {
  const isPrsDockedSidePanelEnabled = isFeatureEnabled('prs_docked_side_panel')
  const panelName = useDockedPanel()
  const agentSessionsDockedSidePanelIsOpen = panelName === 'agentSessions'

  const sidePanelContent = agentSessionsDockedSidePanelIsOpen
    ? ssrSafeDocument?.getElementById(DOCKED_SIDE_PANEL_CONTENT_ID)
    : null

  if (!isOpen) return null

  if (isPrsDockedSidePanelEnabled && sidePanelContent) {
    return createPortal(
      <Panel panelName="agentSessions">
        <Panel.Body>
          <Suspense
            fallback={
              <div className="d-flex flex-justify-center flex-items-center tmp-p-4">
                <Spinner size="medium" />
              </div>
            }
          >
            <PullRequestsSidePanel repository={repository} pullRequestNumber={pullRequestNumber} />
          </Suspense>
        </Panel.Body>
      </Panel>,
      sidePanelContent,
    )
  }

  return null
})
